import { useState } from 'react';
import { createPortal } from 'react-dom';

import { summarizeIskErrorMessage } from '../../utils/iskErrorDisplay';

type Props = {
  errorMessage?: string | null;
  /** 有图残留时的补充说明 */
  hasStaleImage?: boolean;
  emptyPrefix?: string;
};

/** 直觉草图失败：默认短摘要，点击「详情」弹窗看全文 */
export function IskErrorNotice({
  errorMessage,
  hasStaleImage = false,
  emptyPrefix = '上次生成未成功',
}: Props) {
  const [open, setOpen] = useState(false);
  const { summary, full, expandable } = summarizeIskErrorMessage(errorMessage);
  const lead = emptyPrefix;

  const modal = open && typeof document !== 'undefined'
    ? createPortal(
      <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
        <button
          type="button"
          className="absolute inset-0 bg-black/40"
          aria-label="关闭"
          onClick={() => setOpen(false)}
        />
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="isk-error-title"
          className="relative z-10 flex max-h-[min(80dvh,36rem)] w-full max-w-lg flex-col overflow-hidden rounded-lg border border-border bg-surface shadow-xl"
        >
          <div className="flex items-center justify-between border-b border-border px-4 py-3">
            <h3 id="isk-error-title" className="text-sm font-semibold text-ink">生成失败详情</h3>
            <button
              type="button"
              className="rounded-md px-2 py-1 text-xs text-muted hover:bg-black/[0.04] hover:text-ink"
              onClick={() => setOpen(false)}
            >
              关闭
            </button>
          </div>
          <pre className="min-h-0 flex-1 overflow-auto whitespace-pre-wrap break-words px-4 py-3 font-mono text-[11px] leading-relaxed text-ink/85">
            {full || summary}
          </pre>
        </div>
      </div>,
      document.body,
    )
    : null;

  return (
    <div className="space-y-1">
      <p className="text-[11px] leading-snug text-amber-700">
        {lead}
        {summary ? `：${summary}` : ''}
        {hasStaleImage ? ' 若仍有图多为旧图残留，请点「更新直觉草图」。' : ''}
        {expandable && full ? (
          <>
            {' '}
            <button
              type="button"
              className="font-medium text-primary underline-offset-2 hover:underline"
              onClick={() => setOpen(true)}
            >
              查看详情
            </button>
          </>
        ) : null}
      </p>
      {modal}
    </div>
  );
}
